import { z } from 'zod';

export const matchedPaymentMethodsAccountSchema = z.object({
    name: z.string().optional().nullable(),
    id: z.string().optional().nullable(),
    postcode: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
});

export const matchedPaymentMethodsDetailsSchema = z.object({
    accounts: z.array(matchedPaymentMethodsAccountSchema).optional().nullable(),
    expires: z.string().optional().nullable(),
    number: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    subtype: z.string().optional().nullable(),
});

export const matchedPaymentMethod = z.object({
    id: z.string(),
    accountId: z.number(),
    accountName: z.string(),
    channels: z.array(z.string()),
    createdAt: z.string(),
    details: matchedPaymentMethodsDetailsSchema,
    status: z.string(),
    type: z.string(),
    universeId: z.string(),
});
